__turbopack_context__.v({
  "appCard": "navigation-bar-module__uzAxIW__appCard",
  "appSubtitle": "navigation-bar-module__uzAxIW__appSubtitle",
  "appTextWrapper": "navigation-bar-module__uzAxIW__appTextWrapper",
  "appTitle": "navigation-bar-module__uzAxIW__appTitle",
  "appsWrapper": "navigation-bar-module__uzAxIW__appsWrapper",
  "authButtons": "navigation-bar-module__uzAxIW__authButtons",
  "beCreatorButton": "navigation-bar-module__uzAxIW__beCreatorButton",
  "buttonsWrapper": "navigation-bar-module__uzAxIW__buttonsWrapper",
  "canvasSize": "navigation-bar-module__uzAxIW__canvasSize",
  "changeAlias": "navigation-bar-module__uzAxIW__changeAlias",
  "colExplore": "navigation-bar-module__uzAxIW__colExplore",
  "container": "navigation-bar-module__uzAxIW__container",
  "contentApps": "navigation-bar-module__uzAxIW__contentApps",
  "darkTheme": "navigation-bar-module__uzAxIW__darkTheme",
  "divider": "navigation-bar-module__uzAxIW__divider",
  "dropdownButton": "navigation-bar-module__uzAxIW__dropdownButton",
  "dropdownList": "navigation-bar-module__uzAxIW__dropdownList",
  "dropdownWrapper": "navigation-bar-module__uzAxIW__dropdownWrapper",
  "editorButtons": "navigation-bar-module__uzAxIW__editorButtons",
  "exploreLink": "navigation-bar-module__uzAxIW__exploreLink",
  "headerButtons": "navigation-bar-module__uzAxIW__headerButtons",
  "homeButton": "navigation-bar-module__uzAxIW__homeButton",
  "homeIcon": "navigation-bar-module__uzAxIW__homeIcon",
  "left": "navigation-bar-module__uzAxIW__left",
  "logoWrapper": "navigation-bar-module__uzAxIW__logoWrapper",
  "menuDrawer": "navigation-bar-module__uzAxIW__menuDrawer",
  "ozoneBlock": "navigation-bar-module__uzAxIW__ozoneBlock",
  "previewButton": "navigation-bar-module__uzAxIW__previewButton",
  "profileCol": "navigation-bar-module__uzAxIW__profileCol",
  "root": "navigation-bar-module__uzAxIW__root",
  "rootEditor": "navigation-bar-module__uzAxIW__rootEditor",
  "sceneNameWrapper": "navigation-bar-module__uzAxIW__sceneNameWrapper",
  "search": "navigation-bar-module__uzAxIW__search",
  "shareButton": "navigation-bar-module__uzAxIW__shareButton",
  "signInButton": "navigation-bar-module__uzAxIW__signInButton",
  "unityLogo": "navigation-bar-module__uzAxIW__unityLogo",
  "userProfile": "navigation-bar-module__uzAxIW__userProfile",
  "userProfileWrapper": "navigation-bar-module__uzAxIW__userProfileWrapper",
  "webBuilder": "navigation-bar-module__uzAxIW__webBuilder",
  "xsollaText": "navigation-bar-module__uzAxIW__xsollaText",
  "zepeto": "navigation-bar-module__uzAxIW__zepeto",
  "zepetoText": "navigation-bar-module__uzAxIW__zepetoText",
  "zepetoWrapper": "navigation-bar-module__uzAxIW__zepetoWrapper",
});
